import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip, Checkbox } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, SerialActionSelector, HeaderLabel, CellText, DropdownSelector, WarehouseSelector,
} from '../../../components/inventory-components'
import { theme } from '../../../styles/_variables'
import { STATUS, STATUSTEXTSELECTOR } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>วันที่</HeaderLabel>,
    accessor: 'createdAt',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>อ้างอิง</HeaderLabel>,
    accessor: 'refId',
    sortable: false,
    filterable: false,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 300,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>คลังสินค้า</HeaderLabel>,
    accessor: 'Warehouse.warehouseName',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <WarehouseSelector onChange={onChange}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 300,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>จำนวนสต๊อกเดิม</HeaderLabel>,
    accessor: 'oldQuantity',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 120,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>จำนวนสต๊อกใหม่</HeaderLabel>,
    accessor: 'newQuantity',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 120,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ส่วนต่าง</HeaderLabel>,
    accessor: 'quantity',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 120,
    margin: '0 50px',
  }],
}
